import React, { useEffect, useState } from "react";
import { BlogListingSection } from "../../components/blog";
import { FounderHeroSection } from "../../components/founder";
import blogData from "../../data/blogData.json";
import "../founder/founder.css";
import "./blog.css";
import { BaseUrl } from "../../helper/BaseUrl";

export default function Blog({ initialData }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const [allData, setAllData] = useState(initialData || []);
  // API Calling
  const fetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/blogs`, {
        method: 'GET',
      });

      const result = await response.json();

      if (result.blogs === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setAllData(result.blogs);

    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };

  useEffect(() => {
    fetcher();
  }, [])

  if (!allData) {
    return <div style={{ height: "100vh", width: "100%" }}></div>;
  }

  return (
    <main className="blog-page">
      <FounderHeroSection data={blogData.hero} />
      <BlogListingSection allData={allData} />
    </main>
  );
}
